(function () {
  'use strict';

  angular.module('app').component('packageDayDetail', packageDayDetail());

  function packageDayDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        package: '=',
        onPackageDaySaved: '&',
        onPackageDayCanceled: '&',
        defaultLanguage: '<',
      },
      controller: PackageDayDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/package-days/package-day-detail/package-day-detail.component.html',
    };
  }

  PackageDayDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'PackageDayService',
    'HotelService',
    'TourService',
    'TransportationService',
    'ServiceItemService',

    // Angular downgraded service
    'facilityService',
    'facilityModalService',
    'whatToBringService',
    'whatToBringModalService',
    'locationService',
    'locationModalService',
    'utilService',
  ];

  function PackageDayDetailComponent(
    config,
    UtilService,
    $translate,
    $filter,
    PackageDayService,
    HotelService,
    TourService,
    TransportationService,
    ServiceItemService,

    // Angular downgraded service
    facilityService,
    facilityModalService,
    whatToBringService,
    whatToBringModalService,
    locationService,
    locationModalService,
    utilService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    var fieldsDefinition = [
      'meals_included',
      'location_id',
      'hotel_room_ids',
      'tour_option_schedule_ids',
      'transportation_schedule_ids',
      'service_item_ids',
      'facility_ids',
      'what_to_bring_ids',
    ];

    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.mealOptions = config.MEAL_OPTIONS;

    vm.checkedMealsIncluded = [];

    vm.checkedFacility = {};
    vm.checkedWhatToBring = {};

    vm.groupRoomsByHotel = groupRoomsByHotel;
    vm.groupSchedulesByTour = groupSchedulesByTour;
    vm.groupSchedulesByTransportation = groupSchedulesByTransportation;

    // Methods
    vm.openLocationsModal = openLocationsModal;

    vm.openFacilitiesModal = openFacilitiesModal;
    vm.openWhatToBringsModal = openWhatToBringsModal;

    vm.editPackageDay = editPackageDay;
    vm.cancelEdit = cancelEdit;
    vm.savePackageDay = savePackageDay;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        //New
        vm.createMode = true;
      }

      // Initializers
      getLocations();

      // Improve this and call the required 'Add product type'
      getHotels();
      getTours();
      getTransportations();
      getServiceItems();

      getFacilities();
      getWhatToBrings();
    };

    // When selection departure load hotels based on location ??

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editPackageDay();
      }

      setCheckedMealsIncluded(item.meals_included);
      setCheckedFacilities(item.facility_ids);
      setCheckedWhatToBring(item.what_to_bring_ids);

      vm.originalItem = angular.copy(item); // store server data
    }

    function editPackageDay() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    // ----- LOCATIONS ----- //
    function getLocations() {
      var params = {
        get: 'active',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingLocations = true;
      locationService.getLocations(params).subscribe((response) => {
        vm.locations = locationService.groupLocations(response); // , '', 'locations'
        vm.loadingLocations = false;
      });
    }

    function openLocationsModal() {
      locationModalService.openLocationsModal(getLocations);
    }

    // ----- HOTELS ----- // ** Consider async if records are too many
    function getHotels() {
      var params = {
        get: 'active',
        search: true,
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingHotels = true;
      HotelService.getHotels(params).then(function (data) {
        vm.hotels = data.items;

        vm.hotelRooms = [];
        vm.hotels.forEach(function (hotel) {
          hotel.hotel_rooms.forEach(function (room) {
            if (room.status === 'active') {
              vm.hotelRooms.push({
                id: room.id,
                name: room.name,
                hotel: {
                  id: hotel.id,
                  name: hotel.name,
                },
              });
            }
          });
        });

        vm.loadingHotels = false;

        /*vm.hotelRoomOptions = [];
                // Map required multiple select
                HotelService.items.map(function(item) {
                    vm.hotelRoomOptions.push(item);
                });*/

        // if (!HotelService.items.length){ vm.addHotelRooms = true; }

        // if (vm.editMode){ // Edit
        //     // Set selected hotels
        //     var index, hotelRoomOptions = []; // Array
        //     vm.item.hotel_room_ids.forEach(function (option) {

        //         index = findArrayIndex(vm.hotelRoomOptions, 'id', option);

        //         hotelRoomOptions.push(vm.hotelRoomOptions[index]);
        //     });

        //     vm.selectedHotelRooms.selected = hotelRoomOptions;
        // }
      });
    }

    function groupRoomsByHotel(item) {
      return item.hotel.name;
    }

    // ----- TOURS ----- //
    function getTours() {
      var params = {
        get: 'active',
        search: true,
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingTours = true;
      TourService.getTours(params).then(function (data) {
        vm.tours = data.items;

        vm.tourOptionSchedules = [];
        vm.tours.forEach(function (tour) {
          tour.tour_options.forEach(function (tourOption) {
            if (tourOption.status === 'active') {
              tourOption.tour_option_schedules.forEach(function (tourOptionSchedule) {
                if (tourOptionSchedule.status === 'active') {
                  vm.tourOptionSchedules.push({
                    id: tourOptionSchedule.id,
                    departure: tourOptionSchedule.departure,
                    tour_option: {
                      id: tourOption.id,
                      name: tourOption.name,
                      tour: {
                        id: tour.id,
                        name: tour.name,
                      },
                    },
                  });
                }
              });
            }
          });
        });

        vm.loadingTours = false;
      });
    }

    function groupSchedulesByTour(item) {
      return item.tour_option.tour.name + ' / ' + item.tour_option.name;
    }

    // ----- TRANSPORTATION ----- //
    function getTransportations() {
      var params = {
        get: 'active',
        search: true,
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingTransportations = true;
      TransportationService.getTransportations(params).then(function (data) {
        vm.transportations = data.items;

        vm.transportationSchedules = [];
        vm.transportations.forEach(function (transportation) {
          transportation.transportation_schedules.forEach(function (schedule) {
            if (schedule.status === 'active') {
              vm.transportationSchedules.push({
                id: schedule.id,
                departure: schedule.departure,
                transportation: {
                  id: transportation.id,
                  name: transportation.name,
                  product_category: transportation.product_category,
                  schedule_type: transportation.schedule_type,
                },
              });
            }
          });
        });

        vm.loadingTransportations = false;
      });
    }

    function groupSchedulesByTransportation(item) {
      var name = item.transportation.name;
      var product_category = item.transportation.product_category.name;
      var schedule_type = $translate(item.transportation.schedule_type.toUpperCase());

      return name + ' / ' + product_category + ' (' + schedule_type + ')';
    }

    // ----- SERVICE ITEMS ----- //
    function getServiceItems() {
      var params = {
        get: 'active',
        search: true,
        skip_check_role: true,
      };

      vm.loadingServiceItems = true;
      ServiceItemService.getServiceItems(params).then(function (data) {
        vm.serviceItems = data.items;

        vm.loadingServiceItems = false;
      });
    }

    function setCheckedMealsIncluded(meals) {
      meals.forEach(function (meal) {
        vm.checkedMealsIncluded[meal] = true;
      });
    }

    function checkedMealsIncluded() {
      var mealsIncluded = [];
      for (var key in vm.checkedMealsIncluded) {
        if (vm.checkedMealsIncluded[key]) {
          // add only true values to array
          mealsIncluded.push(key);
        }
      }

      return mealsIncluded;
    }

    // ----- FACILITIES ----- //
    function getFacilities() {
      var params = {
        get: 'package',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      facilityService.getFacilities(params).subscribe((response) => {
        vm.facilities = response;
      });
    }

    function openFacilitiesModal() {
      const successCallback = () => {
        getFacilities();
      };

      facilityModalService.openFacilitiesModal(successCallback);
    }

    function setCheckedFacilities(facility_ids) {
      facility_ids.forEach((key) => {
        vm.checkedFacility[key] = true;
      });
    }

    // ----- WHAT TO BRING ----- //
    function getWhatToBrings() {
      var params = {
        get: 'package',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      whatToBringService.getWhatToBrings(params).subscribe((response) => {
        vm.whatToBrings = response;
      });
    }

    function openWhatToBringsModal() {
      const successCallback = () => {
        getWhatToBrings();
      };

      whatToBringModalService.openWhatToBringsModal(successCallback);
    }

    function setCheckedWhatToBring(what_to_bring_ids) {
      vm.isCheckedWhatToBring = true;

      what_to_bring_ids.forEach(function (id) {
        vm.checkedWhatToBring[id] = true;
      });
    }

    // Create/Update
    function savePackageDay(isFormValid) {
      vm.formErrors = false;

      var scrollTo = 'day_detail';

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop(scrollTo);

        return;
      }

      vm.item.meals_included = checkedMealsIncluded();
      vm.item.facility_ids = utilService.parseItemIds(vm.checkedFacility);
      vm.item.what_to_bring_ids = utilService.parseItemIds(vm.checkedWhatToBring);

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        PackageDayService.savePackageDay(vm.item, vm.package.id).then(function (response) {
          if (!response.errors) {
            // Success
            if (!vm.editMode) {
              // create
              vm.item = response; // reload item
            }

            setItemOptions(response);

            vm.onPackageDaySaved({ item: response });

            vm.UtilService.scrollToTop(scrollTo);
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;

            vm.UtilService.scrollToTop(scrollTo);
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onPackageDayCanceled();
    }
  }
})();
